import { Title, Body } from "@vds/typography";
import React from "react";
import styled from 'styled-components';

const StyledPadding = styled.div`
margin-bottom: 10px;
`

const StyledSpoFlexDiv = styled.div`
display:flex;
padding :12px;
background-color: whitesmoke;

`

const StyledWrapUpDiv = styled.div`
padding-top: 16px;

`

const Space = styled.div`
margin-left: 10%;
`


const WrapUp = ({ wrapUpData }) => {
  const outsideUs = wrapUpData?.wrapUp?.postpaid?.outsideUs;
  return (
    <div>
        <Title size="large" bold={true}>
          {outsideUs?.header}
        </Title>
        <StyledWrapUpDiv >
          {outsideUs?.value && outsideUs.value.map((ele, index) => {
            return <StyledPadding><Body size="large">{<span dangerouslySetInnerHTML={{ __html: ele?.key }} />}</Body></StyledPadding>
          })}
        </StyledWrapUpDiv>
        <Title data-testid="wrapUpDataHeader" bold={true}>
          {wrapUpData?.selectedOptionsText}
        </Title>
        <StyledSpoFlexDiv >
          <div>
            <Title bold size="small" >{wrapUpData?.spoCodeText}</Title>
            {wrapUpData.spoCodes.map((ele) => {
              return <Body size="large">{ele?.code}</Body>
            })}
          </div>

          <Space>
            <Title bold size="small" >{wrapUpData?.planNameText}</Title>
            {wrapUpData.planNames.map((ele) => {
              return <Body size="large">{ele?.planName}</Body>
            })}
          </Space>
        </StyledSpoFlexDiv>
        

    </div>
  );

}

export default WrapUp;